import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export default function useResponsiveSidebar(query = "(min-width: 992px)") {
  const mql = useMemo(
    () => (typeof window !== "undefined" ? window.matchMedia(query) : null),
    [query]
  );

  const getDefault = useCallback(() => (mql ? mql.matches : false), [mql]);
  const [open, _setOpen] = useState(getDefault);

  const userOverrode = useRef(false);
  const setOpen = (val) => {
    userOverrode.current = true;
    _setOpen(val);
  };

  useEffect(() => {
    if (!mql) return;
    const handler = (e) => {
      if (!userOverrode.current) _setOpen(e.matches);
    };
    mql.addEventListener?.("change", handler);
    mql.addListener?.(handler);

    _setOpen(getDefault());

    return () => {
      mql.removeEventListener?.("change", handler);
      mql.removeListener?.(handler);
    };
  }, [getDefault, mql]);

  return [open, setOpen];
}
